import React, { useState, useEffect } from 'react';
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { Route, Switch, useLocation } from 'react-router';
import { Container, Alert } from 'reactstrap';
import PublicHome from './components/Home/PublicHome';
import PublicAsideMenu from './components/AsideMenu/PublicAsideMenu';
import PayFees from './components/MakePayment/PayFees';
import History from './components/History/History';
import LinkAccounts from './components/LinkAccounts/LinkAccounts';
import { addLinkedAccount, getLinkedAccounts } from './API';
import QueryString from 'query-string';

function Public() {
    const [environmentWarningVisible, setEnvironmentWarningVisible] = useState(window.env.environment !== 'production');
    let location = useLocation();
    const [linkedAccounts, setLinkedAccounts] = useState([]);
    const [isLoadingLinkedAccounts, setIsLoadingLinkedAccounts] = useState(false);

    useEffect(() => {
        fetchLinkedAccounts();
    }, []);

    const fetchLinkedAccounts = async () => {
        try {
            setIsLoadingLinkedAccounts(true);

            const queryStringParams = QueryString.parse(location.search);
            if (queryStringParams.linkAccountId) {
                const linkAccountId = +(queryStringParams.linkAccountId);
                if (!linkedAccounts.find(l => l.accountID == linkAccountId)) {
                    await addLinkedAccount(linkAccountId);
                }
            }

            const linkedAccountsResult = await getLinkedAccounts();
            setLinkedAccounts(linkedAccountsResult || []);
        } catch (ex) {
            setLinkedAccounts([]);
        } finally {
            setIsLoadingLinkedAccounts(false);
        }
    };

    return (
        <div id="public">
            <Alert className="environment-warning" color="warning" isOpen={environmentWarningVisible} toggle={() => setEnvironmentWarningVisible(false)}>
                <div><strong>Warning:</strong> this is the {window.env.environment} version of the site. Production site: <a href="https://danrfees.appssd.sd.gov">https://danrfees.appssd.sd.gov</a></div>
            </Alert>
            <PublicAsideMenu/>
            <main>
                <Container>
                    <div className="support-message">Please call 605-773-3754 and ask to be transferred to an Environmental Fees program contact if you have questions or need assistance with your account.  Thank you!</div>
                    <TransitionGroup className="transition-group">
                        <CSSTransition key={location.key} classNames="fade" timeout={250}>
                            <section className="route-section">
                                <Switch location={location}>
                                    <Route exact path={['/', '/home']} render={(props) => <PublicHome {...props} fetchLinkedAccounts={fetchLinkedAccounts} linkedAccounts={linkedAccounts} isLoadingLinkedAccounts={isLoadingLinkedAccounts} /> } />
                                    <Route exact path='/payFees' render={(props) => <PayFees {...props} fetchLinkedAccounts={fetchLinkedAccounts} linkedAccounts={linkedAccounts} isLoadingLinkedAccounts={isLoadingLinkedAccounts} />}/>
                                    <Route exact path='/history' render={(props) => <History {...props} fetchLinkedAccounts={fetchLinkedAccounts} linkedAccounts={linkedAccounts} isLoadingLinkedAccounts={isLoadingLinkedAccounts} />} />
                                    <Route exact path='/linkAccounts' render={(props) => <LinkAccounts {...props} fetchLinkedAccounts={fetchLinkedAccounts} linkedAccounts={linkedAccounts} isLoadingLinkedAccounts={isLoadingLinkedAccounts} /> } />
                                </Switch>
                            </section>
                        </CSSTransition>
                    </TransitionGroup>
                </Container>
            </main>
        </div>  
    );
}

export default Public;